const microbiologistNodes = [
    {
        id: '1',
        position: { x: 100, y: 100 },
        data: {
            label: 'High school',
            nodeName: 'high-school',
            nodeType: 'current-path',
            description: 'Excited about this career? This is where your career journey begins.',
            completionLabel: 'I’ve finished high school',
            dataRows: [
                {title: 'Years of study', subTitle: '4 years', iconName: 'calendar-clock'},
                {title: 'Required credits to complete', subTitle: '20 to 24', iconName: 'hash'},
                {title: 'Subjects', subTitle: 'Science, technology and mathematics focused', iconName: 'career-subjects'},
            ],
            guide: {
                overview: 'For a full list of requirements, check out the high school guide.',
                details: {
                    description: 'Here’s a list of requirements along with recommended extras to help you prepare for college. Consider AP classes if available, or look into dual enrolment options.',
                    requiredSubjects: [
                        {
                            title: 'Core subjects',
                            description: 'You’ll need to take at least one class in each core subject.',
                            subjects: [
                                {
                                    title: 'Science',
                                    description: 'Research, lab techniques, and biology will build the skills needed for this role’s core duties.',
                                    checklist: [
                                        'AP Biology',
                                        'AP Chemistry',
                                    ],
                                },
                                {
                                    title: 'Mathematics',
                                    description: 'Research, lab techniques, and biology will build the skills needed for this role’s core duties.',
                                    checklist: [
                                        'AP Algebra',
                                        'AP Calculas',
                                    ],
                                },
                                {
                                    title: 'English',
                                    description: 'Research, lab techniques, and biology will build the skills needed for this role’s core duties.',
                                    checklist: [
                                        'AP English Language and Composition',
                                        'Technical writing',
                                        'Communication',
                                    ],
                                },
                            ],
                        },
                        {
                            title: 'Electives',
                            description: 'You’ll need to take at least one class in each core subject.',
                            subjects: [
                                {
                                    title: 'Science',
                                    description: 'Enhance your skills in research, lab techniques, and biology.',
                                },
                                {
                                    title: 'Computer Science/IT',
                                    description: 'Essential skills for data analysis and documenting experiments.',
                                },
                            ],
                        },
                    ],
                    optionalSubjects: [
                        {
                            title: 'Extra curricular activities',
                            description: 'Helps you develop teamwork and experience, making you more attractive to employers.',
                            subjects: [
                                {
                                    title: 'Clubs',
                                    description: 'Gain practical experience and build essential skills.',
                                    checklist: [
                                        'Science Club',
                                        'Science Olympaid',
                                    ],
                                },
                                {
                                    title: 'Volunteering',
                                    description: 'Gives you experience with tools and techniques.',
                                    checklist: [
                                        'Technical workshops',
                                        'Local labs',
                                        'Environmental organizations',
                                    ],
                                },
                            ],
                        },
                        {
                            title: 'Career readiness',
                            description: 'It’s never too early to start planning your future.',
                            subjects: [
                                {
                                    title: 'Internships',
                                    description: 'Helps you develop essential skills through real-world exposure.',
                                },
                                {
                                    title: 'Career comparison',
                                    description: 'Helps you identify and compare what is most important to you.',
                                },
                            ],
                        },
                    ],
                }
            }
        },
        className: 'current-path'
    },
    {
        id: '2',
        position: { x: 103, y: 200 },
        data: {
            label: 'Bachelor\'s',
            nodeName: 'bachelors',
            nodeType: 'typical',
            description: '',
            completionLabel: 'I\'ve finished a bachelor\'s degree',
            dataRows: []
        },
        className: 'typical'
    },
    {
        id: '3',
        position: { x: 90, y: 300 },
        data: {
            label: 'Entry-level jobs',
            nodeName: 'entry-level-jobs',
            nodeType: 'typical',
            description: 'After earning your bachelor’s or associate degree and completing an internship, you’ll be ready to begin your career as a biological technician.',
            completionLabel: 'I\'ve finished an entry-level job',
            dataRows: [
                {title: 'Years of experience', subTitle: '0 to 3 years', iconName: 'calendar-clock'},
            ],
            otherCareers: [
                {title: 'Histotechnologist', url: '#'},
                {title: 'Lab Technologist', url: '#'},
                {title: 'Pathologist Assistant', url: '#'},
            ],
        },
        className: 'typical'
    },
    {
        id: '4',
        position: { x: 94, y: 400 },
        data: {
            label: 'Mid-level jobs',
            nodeName: 'mid-level-jobs',
            nodeType: 'typical',
            description: 'After earning your master’s or doctoral degree, or gaining 1 to 3 years of experience as a biological technician, you can advance into more experienced roles',
            completionLabel: 'I\'ve finished a mid-level job',
            dataRows: [
                {title: 'Years of experience', subTitle: '3 to 5 years', iconName: 'calendar-clock'},
            ],
            otherCareers: [
                {title: 'Histotechnologist', url: '#'},
                {title: 'Lab Technologist', url: '#'},
                {title: 'Pathologist Assistant', url: '#'},
            ],
        },
        className: 'typical'
    },
    {
        id: '5',
        position: { x: 22, y: 150 },
        data: {
            label: 'Associate',
            nodeName: 'associate',
            nodeType: 'alternative',
            description: '',
            completionLabel: 'I\'ve finished an associate degree',
            dataRows: []
        },
        className: 'alternative'
    },
    {
        id: '6',
        position: { x: 21, y: 250 },
        data: {
            label: 'Internship',
            nodeName: 'internship',
            nodeType: 'alternative',
            description: '',
            completionLabel: 'I\'ve finished an internship',
            dataRows: []
        },
        className: 'alternative'
    },
    {
        id: '7',
        position: { x: 190, y: 250 },
        data: {
            label: 'Master\'s',
            nodeName: 'masters',
            nodeType: 'alternative',
            description: 'A master’s degree may over qualify you for a biological technician role, but it opens doors to more advanced positions and lets you bypass entry-level jobs.',
            completionLabel: 'I\'ve finished a master\'s degree',
            dataRows: [
                {title: 'Duration', subTitle: '2 years', iconName: 'calendar-clock'},
                {title: 'Required credits to complete', subTitle: '30 to 36', iconName: 'hash'},
                {title: 'Degrees', subTitle: 'Microbiology, biochemistry or natural science management focused', iconName: 'career-subjects'},
            ],
            guide: {
                overview: 'Since the steps vary depending on the college and type of degree, we can’t provide a detailed guide. We recommend speaking your campus career counsellor for guidance on further studies.',
            }
        },
        className: 'alternative'
    },
    {
        id: '8',
        position: { x: 190, y: 350 },
        data: {
            label: 'Doctoral',
            nodeName: 'doctoral',
            nodeType: 'alternative',
            description: 'A doctoral degree may significantly over qualify you for a biological technician role, but it paves the way for leadership or specialized research positions that demand higher expertise.',
            completionLabel: 'I\'ve finished a doctoral degree',
            dataRows: [
                {title: 'Duration', subTitle: '4 to 6 years', iconName: 'calendar-clock'},
                {title: 'Required credits to complete', subTitle: '60 to 120', iconName: 'hash'},
                {title: 'Degrees', subTitle: 'Microbiology, biochemistry or natural science management focused', iconName: 'career-subjects'},
            ],
            guide: {
                overview: 'Since the steps vary depending on the college and type of degree, we can’t provide a detailed guide. We recommend speaking your campus career counsellor for guidance on further studies.',
            }
        },
        className: 'alternative'
    },
];

const microbiologistEdges = [
    {
        id: '1-2',
        source: '1',
        target: '2',
        style: { stroke: '#80D2C9' },
    },
    {
        id: '2-3',
        source: '2',
        target: '3',
        style: { stroke: '#80D2C9' },
    },
    {
        id: '3-4',
        source: '3',
        target: '4',
        style: { stroke: '#80D2C9' },
    },
    {
        id: '1-5',
        source: '1',
        target: '5',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '5-6',
        source: '5',
        target: '6',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '2-6',
        source: '2',
        target: '6',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '5-2',
        source: '5',
        target: '2',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '6-3',
        source: '6',
        target: '3',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '2-7',
        source: '2',
        target: '7',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '7-8',
        source: '7',
        target: '8',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '7-3',
        source: '7',
        target: '3',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '7-4',
        source: '7',
        target: '4',
        style: { stroke: '#CCD5EC' },
    },
    {
        id: '8-4',
        source: '8',
        target: '4',
        style: { stroke: '#CCD5EC' },
    },
];

type MAPPING_TYPE = {
    [key: string]: any;
};

export const CAREERS_NODES_MAPPING: MAPPING_TYPE = {
    microbiologist: microbiologistNodes,
};

export const CAREERS_EDGES_MAPPING: MAPPING_TYPE = {
    microbiologist: microbiologistEdges,
};
